import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/WiFi/u7-lr@2x.jpg";
import v3Image from "../../assets/Flagship/u7lr.jpg";
import type { Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifi-flagship";

export const u7lr: Product = {
  id: "u7LR",
  productTitle: "U7 Long-Range",
  techspecsPath: [SiteId.TechSpecs, "/unifi/wifi/u7-lr"],
  storePathParts: { productSlug: "u7-lr", category: "wifi-flagship" },
  description: "u7LR.description.1",
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 207,
    height: 182,
  },
  isNew: true,
  productListGroup: wifiFlagship,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "translation",
        value: "u7LR.dimensions",
      },
    },
    {
      propertyId: "wifiTechnology",
      value: {
        type: "translation",
        value: "u7LR.wifiTechnology",
      },
    },
    {
      propertyId: "radio6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "coverage",
      value: { type: "string", value: "160 m² (1,750 ft²)" },
    },
    {
      propertyId: "connectedDevices",
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: "uplink",
      value: { type: "string", value: "2.5/1 GbE" },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
